/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type { CreateJournalEntryDto, GetJournalByPatientParams, JournalDto } from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const markJournalAsDone = (id: string, options?: SecondParameter<typeof request>) => {
  return request<void>({ url: `/api/journal/${id}/done`, method: 'PUT' }, options);
};

export const getMarkJournalAsDoneMutationOptions = <
  TData = Awaited<ReturnType<typeof markJournalAsDone>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['markJournalAsDone'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof markJournalAsDone>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return markJournalAsDone(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { id: string }, TContext>;
};

export type MarkJournalAsDoneMutationResult = NonNullable<Awaited<ReturnType<typeof markJournalAsDone>>>;

export type MarkJournalAsDoneMutationError = ErrorType<unknown>;

export const useMarkJournalAsDone = <
  TData = Awaited<ReturnType<typeof markJournalAsDone>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string }, TContext> => {
  const mutationOptions = getMarkJournalAsDoneMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getJournalByPatient = (
  params: GetJournalByPatientParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<JournalDto[]>({ url: `/api/journal`, method: 'GET', params, signal }, options);
};

export const getGetJournalByPatientQueryKey = (params: GetJournalByPatientParams) => {
  return [`/api/journal`, ...(params ? [params] : [])] as const;
};

export const getGetJournalByPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJournalByPatientQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJournalByPatient>>> = ({ signal }) =>
    getJournalByPatient(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJournalByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJournalByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getJournalByPatient>>>;
export type GetJournalByPatientQueryError = ErrorType<unknown>;

export function useGetJournalByPatient<
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJournalByPatient<
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJournalByPatient<
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetJournalByPatient<
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetJournalByPatientQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetJournalByPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJournalByPatientQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJournalByPatient>>> = ({ signal }) =>
    getJournalByPatient(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getJournalByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJournalByPatientSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getJournalByPatient>>>;
export type GetJournalByPatientSuspenseQueryError = ErrorType<unknown>;

export function useGetJournalByPatientSuspense<
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJournalByPatientSuspense<
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJournalByPatientSuspense<
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetJournalByPatientSuspense<
  TData = Awaited<ReturnType<typeof getJournalByPatient>>,
  TError = ErrorType<unknown>,
>(
  params: GetJournalByPatientParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getJournalByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetJournalByPatientSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createJournalEntry = (
  createJournalEntryDto: BodyType<CreateJournalEntryDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/journal`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createJournalEntryDto,
      signal,
    },
    options,
  );
};

export const getCreateJournalEntryMutationOptions = <
  TData = Awaited<ReturnType<typeof createJournalEntry>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateJournalEntryDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createJournalEntry'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createJournalEntry>>,
    { data: BodyType<CreateJournalEntryDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createJournalEntry(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateJournalEntryDto> },
    TContext
  >;
};

export type CreateJournalEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createJournalEntry>>>;
export type CreateJournalEntryMutationBody = BodyType<CreateJournalEntryDto>;
export type CreateJournalEntryMutationError = ErrorType<unknown>;

export const useCreateJournalEntry = <
  TData = Awaited<ReturnType<typeof createJournalEntry>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateJournalEntryDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateJournalEntryDto> }, TContext> => {
  const mutationOptions = getCreateJournalEntryMutationOptions(options);

  return useMutation(mutationOptions);
};
